import { z } from 'zod';

// Common values seen across similar Laravel apps — not confirmed against
// App\Enums\... for this backend specifically. Rendered as a select with
// these plus a free-text fallback (see RecordPaymentForm) rather than a
// hard enum, since restricting to a guessed list could block a legitimate
// value the real enum allows.
export const PAYMENT_METHOD_SUGGESTIONS = ['bank_transfer', 'cash', 'card', 'cheque'];

// Built per-investment (bounds the amount against that investment's
// current remaining balance) — the server re-validates this on submit and
// is the final authority, but blocking an obviously-over-funding entry
// client-side saves a round trip.
export function buildRecordPaymentSchema(remainingAmount) {
  const max = remainingAmount != null ? Number(remainingAmount) : null;

  return z.object({
    amount: z.coerce
      .number({ invalid_type_error: 'Enter an amount' })
      .positive('Enter an amount greater than 0')
      .refine((v) => max == null || v <= max, () => ({ message: `Cannot exceed the remaining amount (${max?.toLocaleString()})` })),
    method: z.string().min(1, 'Enter a payment method'),
    provider: z.string().optional(),
    provider_reference: z.string().optional(),
    note: z.string().optional(),
  });
}
